import React from 'react';



const Officer25 = () => {

  return (
    <div>
      <div className='blog__container'>
        <div class="row">
            <div class="column">
                <header></header>

                <section>
                    <h2>WiC Officer Board 2024-2025 Announcement</h2>
                    <p class="site-post-meta"></p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                    Hi WiC members! 
                    <br></br>
                    <br></br>
                    Thank you to everybody who supported and ran in this year’s elections. 
                    We are excited to announce the new officer board for next year!
                    <br></br>
                    <br></br>
                    Chair: Shreya Sathyanarayanan
                    <br></br>
                    <br></br>
                    Vice Chair: Manasa Lingireddy
                    <br></br>
                    <br></br>
                    Student Relations Director: Shrima Narasimhan
                    <br></br>
                    <br></br>
                    Public Relations Director: Jeewon Jung
                    <br></br>
                    <br></br>
                    Outreach Director: Arya Sanjay
                    <br></br>
                    <br></br>
                    Social Events Director: Chi Dang
                    <br></br>
                    <br></br>
                    Secretary/Treasurer: Isha Jagadish
                    <br></br>
                    <br></br>
                    Social Media Director: Athena Bao
                    <br></br>
                    <br></br>
                    Congratulations to the incoming officer board! 
                    We can't wait to see what you all will accomplish.
                    <br></br>
                     
                    </p>
                   
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
export default Officer25

